import React from "react";
import { Navigate } from "react-router-dom";

import { PATTERNS } from "~/router";

import { useFeatureFlag } from "./useFeatureFlag";

type FeatureGateProps = {
  feature: string;
  children: React.ReactNode;
  redirectToRoot?: boolean;
};

export const FeatureGate: React.FC<FeatureGateProps> = ({
  feature,
  children,
  redirectToRoot = false,
}) => {
  const enabled = useFeatureFlag(feature);

  return enabled ? (
    <>{children}</>
  ) : redirectToRoot ? (
    <Navigate to={PATTERNS.home} replace />
  ) : null;
};
